import { Icon, IconDisplay, IconSize } from "@components/Icon";
import { Popover } from "@components/Popover";

import { horizontalStackCss } from "src/theme/spacing";
import { textSizeCss } from "src/theme/text";

export const CoverVideoPopover = () => (
  <Popover
    placement={"bottom"}
    css={{ cursor: "help" }}
    content={
      <div css={[horizontalStackCss.xs, { maxWidth: "320px" }]}>
        <Icon
          css={{ flexShrink: 0 }}
          iconImport={() =>
            import("@components/Icon/icons/YoutubeLogoCircleIcon")
          }
          display={IconDisplay.SECONDARY}
          size={IconSize.MEDIUM}
        />
        <div>
          <h6 css={[textSizeCss.s]}>Cover video</h6>
          <p>
            Specify a YouTube video to replace the cover image for your
            fundraiser.
          </p>
        </div>
      </div>
    }
  >
    <Icon
      iconImport={() => import("@components/Icon/icons/QuestionCircleIcon")}
      display={IconDisplay.SECONDARY}
      size={IconSize.MEDIUM}
    />
  </Popover>
);
